import { render, staticRenderFns } from "./QuotationApprove.vue?vue&type=template&id=7571fd00&"
import script from "./QuotationApprove.vue?vue&type=script&lang=js&"
export * from "./QuotationApprove.vue?vue&type=script&lang=js&"
import style0 from "./QuotationApprove.vue?vue&type=style&index=0&id=7571fd00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports